import Vue from 'vue'
import Intercom from '@intercom/messenger-js-sdk'
const jwt = require('jsonwebtoken')

export default function({ app: { router }, store }, inject) {

  // Determine if user is logged in
  const isLoggedIn = (auth) => {
    if (!auth || !auth.account || !auth.account.promoterOid) {
      return false
    }

    return true
  }

  // Generate JWT token for Intercom user verification
  const generateIntercomJWT = (userProperties) => {
    // Check if the Intercom API secret is available
    if (!process.env.AR_INTERCOM_API_SECRET) {
      console.warn('AR_INTERCOM_API_SECRET not configured, skipping Intercom JWT generation')
      return null
    }

    const payload = {
      user_id: userProperties.oid,
      email: userProperties.emailAddress,
      sensitive_attribute1: userProperties.companyName,
      sensitive_attribute2: userProperties.promoterOid,
      sensitive_attribute3: userProperties.firstName + ' ' + userProperties.lastName,
    }

    return jwt.sign(payload, process.env.AR_INTERCOM_API_SECRET, { expiresIn: '1h' })
  }

  // Get and set properties of logged in user (i.e company name, email address etc)
  // It allows us to add user properties to Intercom
  const setUserProperties = (auth) => {
    const account = auth?.account || {}
    const userProps = {
      oid: account.oid || '',
      promoterOid: account.promoterOid || '',
      companyName: account.companyName || '',
      emailAddress: account.emailAddress || '',
      firstName: account.firstName || '',
      lastName: account.lastName || '',
    }
    
    // Generate JWT token
    userProps.intercomUserJwt = generateIntercomJWT(userProps)
    
    return userProps
  }

  // Make sure that pageviews are captured with each route change
  router.afterEach(to => {
    const {
      auth
    } = store._modules.root.state

    // Ensure user is logged in
    if (!isLoggedIn(auth))
      return

    let userProperties = setUserProperties(auth)

    // Skip Intercom initialization if JWT generation failed
    if (!userProperties.intercomUserJwt) {
      console.warn('Intercom disabled: AR_INTERCOM_API_SECRET not configured')
      return
    }

    Intercom({
      api_base: "https://api-iam.intercom.io",
      app_id: process.env.arIntercomFinAppId,
      intercom_user_jwt: userProperties.intercomUserJwt,
      user_id: userProperties.oid,
      name: userProperties.firstName + ' ' + userProperties.lastName,
      email: userProperties.emailAddress,
      company: {
        company_id: userProperties.promoterOid,
        name: userProperties.companyName
      }
    })
  })
}
